import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAdminReport } from "../../Hooks/Admin/useReport";
import { useAdminInvoices } from "../../Hooks/Admin/useInvoices";
import dayjs from "dayjs";
import { Col, Empty, Row } from "antd";

const Index = () => {
  const dispatch = useDispatch();

  const userData = useSelector((state) => state.user.data);

  const { getDashboardReports } = useAdminReport();
  const { getAllUser } = useAdminInvoices();

  const [userList, setuserList] = React.useState([]);
  const [userReport, setuserReport] = React.useState([]);

  useEffect(() => {
    get_report_data();
    get_all_users();
  }, []);

  const get_all_users = async () => {
    try {
      const data = await getAllUser(dispatch);
      if (data.length > 0) {
        const arr = [];
        data.map((item) => {
          arr.push({ label: item.name, value: item.id });
        });
        setuserList(arr);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const get_report_data = async () => {
    try {
      const data = await getDashboardReports(dispatch);
      console.log(data.data);
      setuserReport(data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const getRandomColor = () => {
    return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
  };
  return (
    <div>
      <div
        style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "20px" }}
      >
        {dayjs().format("MMMM")} Invoice Missing
      </div>
      {userReport.length > 0 ? (
        <Row gutter={[16, 16]}>
          {userReport.map((user, index) => {
            const color = getRandomColor();
            return (
              <Col key={index} span={6}>
                <div
                  style={{
                    backgroundColor: color + "33",
                    border: `1px solid ${color}`,
                    color: "#000000",
                    padding: "20px",
                    borderRadius: "8px",
                    textAlign: "center",
                  }}
                >
                  {userList.filter((item) => item.value === user)[0]?.label}
                </div>
              </Col>
            );
          })}
        </Row>
      ) : (
        <Empty
          style={{
            border: "1px solid #d9d9d9",
            padding: "50px",
            borderRadius: "8px",
          }}
        />
      )}
    </div>
  );
};

export default Index;
